export default "__VITE_ASSET__04c50d84__"